import { useState } from "react"
import { useStore } from "../../stores/store"
import { companyModalStore, sendInvite } from "../../stores/companyModalStore"
import { useBootstrap, useTranslations } from "../../lib/translations"

function InviteRow({ invitation }) {
  const t = useTranslations()
  const [copied, setCopied] = useState(false)
  const fullUrl = invitation.accept_url ? window.location.origin + invitation.accept_url : null

  const copy = () => {
    if (!fullUrl) return
    navigator.clipboard?.writeText(fullUrl)
    setCopied(true)
    setTimeout(() => setCopied(false), 1800)
  }

  return (
    <div className={`cm-invite-row ${invitation.pending ? "" : "accepted"}`}>
      <div className="cm-invite-row-head">
        <span className="mono">{invitation.email}</span>
        <span className="cm-invite-status mono">
          {invitation.pending ? t("company_modal.invite.status_pending") : t("company_modal.invite.status_accepted")}
        </span>
        {(invitation.roles || []).map((r) => (
          <span key={r} className="cm-rolepill">{r}</span>
        ))}
      </div>
      {fullUrl && invitation.pending && (
        <div className="cm-invite-url">
          <code className="cm-invite-url-text" title={fullUrl}>{fullUrl}</code>
          <button type="button" className="cm-copy-link" onClick={copy}>
            {copied ? t("company_modal.invite.copied") : t("company_modal.invite.copy_link")}
          </button>
        </div>
      )}
    </div>
  )
}

export function InvitationsTab() {
  const t = useTranslations()
  const bootstrap = useBootstrap()
  const invitations = useStore(companyModalStore, (s) => s.invitations)
  const inviting = useStore(companyModalStore, (s) => s.inviting)
  const error    = useStore(companyModalStore, (s) => s.inviteError)

  const availableRoles = bootstrap.available_roles || []
  const [email, setEmail] = useState("")
  const [roles, setRoles] = useState(["viewer"])

  const submit = async (e) => {
    e?.preventDefault?.()
    if (!email.trim() || inviting) return
    try {
      await sendInvite(bootstrap.paths, { email: email.trim(), roles })
      setEmail("")
      setRoles(["viewer"])
    } catch (err) {
      // error rendered below
    }
  }

  const toggleRole = (r) => {
    setRoles((prev) => prev.includes(r) ? prev.filter((x) => x !== r) : [...prev, r])
  }

  return (
    <div className="cm-tabwrap">
      <form className="cm-invite-form" onSubmit={submit}>
        <div className="cm-field">
          <label>{t("company_modal.invite.email")}</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                 placeholder="person@company.com" required disabled={inviting} />
        </div>
        <div className="cm-field">
          <label>{t("company_modal.invite.roles")}</label>
          <div className="cm-role-checks">
            {availableRoles.map((r) => (
              <label key={r} className={`cm-role-check ${roles.includes(r) ? "on" : ""}`}>
                <input type="checkbox" checked={roles.includes(r)} onChange={() => toggleRole(r)} />
                <span>{r}</span>
              </label>
            ))}
          </div>
        </div>
        {error && <div className="cm-coming-soon" style={{ color: "var(--bad)" }}>{error}</div>}
        <button type="submit" disabled={inviting || !email.trim() || roles.length === 0}>
          {inviting ? t("company_modal.invite.sending") : t("company_modal.invite.send")}
        </button>
      </form>

      <h4 style={{ margin: "20px 0 8px", fontFamily: '"Fraunces", serif' }}>
        {t("company_modal.invite.list_heading")}
      </h4>
      <p className="cm-invite-hint">{t("company_modal.invite.share_hint")}</p>
      <div className="cm-invite-list">
        {invitations.map((i) => (
          <InviteRow key={i.id} invitation={i} />
        ))}
        {invitations.length === 0 && (
          <div className="cm-coming-soon">{t("company_modal.invite.empty")}</div>
        )}
      </div>
    </div>
  )
}
